<template>
  <div
    :class="[
      'flex',
      'flex-col',
      'md:flex-row',
      'md:justify-between',
      'md:items-center',
      'py-16',
      'border-b-md',
      'border-solid',
      'border-border-secondary',
    ]"
  >
    <div class="">
      <slot name="left"></slot>
    </div>
    <div class="flex flex-col md:items-end" aria-live="polite" aria-atomic>
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style></style>
